import styled from "styled-components";
import LinkTotalTitle from "../../atoms/link/LinkTotalTitle";
import LinkPieChart from "../../atoms/link/LinkPieChart";
import LinkLegend from "../../molecules/link/LinkLegendBox";
import { CHART_COLORS, CLOUDN_COLORS } from "../../../constants/colors";
import { LinkDeviceQuantityCardProps } from "../../../constants/types";
import { useEffect, useState } from "react";

const LinkDeviceQuantityCard = (props: LinkDeviceQuantityCardProps) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(
      props.qty.list.map((data, index) => ({
        id: data.name === "공공기관, 기타 상업 건물(해외)" ? "기타" : data.name,
        label: data.name,
        value: data.total,
        disconnected: data.disconnectedDevice,
        color: CHART_COLORS[index],
      }))
    );
  }, [props.qty.list]);

  return (
    <Container>
      <LinkTotalTitle
        total={props.qty.total}
        disconnected={props.qty.disconnectedTotal}
      />
      <LinkPieChart data={data} />
      <LinkLegend data={data} />
    </Container>
  );
};

export default LinkDeviceQuantityCard;

const Container = styled.div`
  width: 25%;
  height: 100%;
  box-sizing: border-box;
  border: 0.2vw solid ${CLOUDN_COLORS.logoSkyBlue};

  display: flex;
  align-content: space-between;
  justify-content: center;
  flex-wrap: wrap;
  padding: 1%;
`;
